import { getPractices } from 'api/Practice';
import { getUsersAndAdmins } from 'api/User';

import { formatDate } from 'lib/helpers/utility';

export const DEFAULT_FILTERS = {
  created_at: {
    values: null,
    type: 'date-range',
    title: 'Created At',
    preview: (values) => `${formatDate(values.startDate)} - ${formatDate(values.endDate)}`
  },
  status: {
    type: 'search',
    multiple: true,
    title: 'Status',
    options: [
      { label: 'Initiated', value: 'initiated' },
      { label: 'Processing', value: 'processing' },
      { label: 'Complete', value: 'complete' }
    ]
  },
  practice: {
    type: 'infinite-scroll',
    multiple: true,
    values: [],
    queryKey: 'practices',
    queryFn: getPractices,
    title: 'Practices',
    placeholder: 'Search practices',
    params: { limit: 25, withCount: true, select_fields: ['id', 'name'] },
    formatData: (data) => [
      { label: 'Admin User', value: null },
      ...data.map((practice) => ({
        label: practice?.name,
        value: practice?.id
      }))
    ]
  },
  model: {
    type: 'search',
    title: 'Model',
    values: ''
  },
  user: {
    type: 'infinite-scroll',
    values: [],
    queryFn: getUsersAndAdmins,
    queryKey: 'users_and_admins',
    multiple: true,
    title: 'Users',
    placeholder: 'Search users',
    params: {
      limit: 25,
      select_fields: ['id', 'f_name', 'l_name'],
      kind: 'practitioner'
    },
    formatData: (data) =>
      data.map((user) => ({
        label: `${user?.f_name} ${user?.l_name}`,
        value: user?.id
      }))
  },
  request: {
    type: 'search',
    title: 'Request Body',
    values: ''
  },
  response: {
    type: 'search',
    title: 'Response Body',
    values: ''
  }
};
